import useRequest from "@/utils/useRequest";

const request = useRequest();
import { useStore } from "vuex";

/**
 * 产品
 */
export function requestProductList(data) {
  return request({
    url: "/api/public/after_sale_failure/product_info/query/list",
    method: "post",
    data,
  });
}

/**
 * 根据产品获取问题
 */
export function requestQuestionTree(productName) {
  const store = useStore();
  return request({
    url: "/api/public/after_sale_failure/query/tree",
    method: "post",
    data: {
      productName: productName,
      siteCode: store.state.siteCode,
    },
  });
}

/**
 * 根据产品获取问题
 */
export function requestQuestionPlan(questionId) {
  return request({
    url: "/api/public/after_sale_failure/query/question_solution",
    method: "get",
    params: {
      questionId: questionId,
    },
  });
}

/**
 * 操作记录
 * @return {*}
 */
export function saveOperRecord(data) {
  return request({
    url: "/api/public/after_sale_failure/k_sys_operation_record/add ",
    method: "POST",
    data,
  });
}

export function getSiteLanList() {
  return request({
    url: "/api/public/after_sale_failure/query/site/list",
    method: "get",
  });
}

export function getSiteSettings() {
  return request({
    url: "/api/public/after_sale_failure/query/sys_param_resource/list",
    method: "get",
  });
}
